import React from 'react';
import {
  Typography,
  Paper
} from '@mui/material';

const LoadingScreen = () => {
  return (
    <Paper elevation={3} sx={{ padding: 4, width: '100%', textAlign: 'center' }}>
      <Typography variant="h6">Loading...</Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Logging in and fetching your job posts...
      </Typography>
    </Paper>
  );
};

export default LoadingScreen; 